// event-registration-form-app/main.jsx
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";

console.log("[event-registration] app loading...");

document.addEventListener("DOMContentLoaded", function () {
  const appElement = document.getElementById("event-registration-form-app");
  if (appElement) {
    console.log("[event-registration] container found");
    const root = createRoot(appElement);
    root.render(<App />);
  } else {
    console.log("[event-registration] container not found");
  }
});
